export const SATIN_JOB_EVENT = "trace:satin-job-update";

export function publishSatinJob(detail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SATIN_JOB_EVENT, { detail }));
}

export function parseSatinJobContext(context) {
  try {
    const [fileId, layerIndex] = JSON.parse(context);
    if (typeof layerIndex !== "number") return null;
    return { fileId, layerIndex };
  } catch {
    return null;
  }
}
